"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11zm-2-.79V18H4V6h12z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "10",
  cy: "10",
  r: "2"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M14 15.43c0-.81-.48-1.53-1.22-1.85-.85-.37-1.79-.58-2.78-.58s-1.93.21-2.78.58C6.48 13.9 6 14.62 6 15.43V16h8z"
}, "2")], 'VideoCameraFrontOutlined');